import axios from "axios";
import { jwtDecode } from "jwt-decode";

// production baseURL 
//const BASE_URL = "https://backend.bricksnmix.com";

// development baseURL
const BASE_URL = "https://uat-backend.bricksnmix.com";

const token = localStorage.getItem("token");
const refreshToken = localStorage.getItem("refresh");
let sessionId = localStorage.getItem("sessionid");

// console.log("token", token);

// Set headers based on the presence of either the token or sessionId
const headers = token
  ? { Authorization: `JWT ${token}` } // If token exists, use it for Authorization
  : sessionId
    ? { "Session-Id": sessionId } // If token does not exist, use sessionId
    : {}; // Default to an empty object if neither exists

// Initialize the Axios instance with the proper headers
const USER_URL = axios.create({
  baseURL: BASE_URL,
  headers: headers, // Use the dynamic headers
});

// Variables to handle token refresh and queued requests
let isRefreshing = false; // Flag to check if a token refresh is in progress
let failedRequests = []; // Queue for failed requests during token refresh

// Helper function to clear tokens from localStorage
const clearAuthTokens = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("refresh");
  localStorage.removeItem("user");
};

// Function to refresh the access token using the refresh token
const refreshAccessToken = async () => {
  try {
    const refreshToken = localStorage.getItem("refresh");
    if (!refreshToken) {
      throw new Error("No refresh token available");
    }

    const { data } = await axios.post(`${BASE_URL}/accounts/token/refresh/`, {
      refresh: refreshToken,
    });

    localStorage.setItem("token", data.access);
    localStorage.setItem("refresh", data.refresh);

    return data.access;
  } catch (error) {
    clearAuthTokens();
    window.location.href = "/login/email";

    throw error;
  }
};

// Request interceptor to attach the access token to requests
USER_URL.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("token");
    if (accessToken) {
      config.headers.Authorization = `JWT ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle token expiration and refresh
USER_URL.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedRequests.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers.Authorization = `JWT ${token}`;
            return axios(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const newAccessToken = await refreshAccessToken();
        originalRequest.headers.Authorization = `JWT ${newAccessToken}`;
        const retryResponse = await axios(originalRequest);

        failedRequests.forEach((request) => request.resolve(newAccessToken));
        failedRequests = [];
        isRefreshing = false;

        return retryResponse;
      } catch (refreshError) {
        failedRequests.forEach((request) => request.reject(refreshError));
        failedRequests = [];
        isRefreshing = false;

        clearAuthTokens();
        window.location.href = "/login/email";
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export { USER_URL, BASE_URL };
